import axios from "axios";

let serve = axios.create({});

serve.interceptors.request.use((config) => {
  return config;
});

serve.interceptors.response.use((res) => {
  return res;
});

export default serve;
